"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = require("rxjs/operators");
/**
 * @author tatevik.marikyan
 * @since 30/07/2018
 */
var core_1 = require("@angular/core");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var model_1 = require("../model");
var immutable_1 = require("immutable");
var of_1 = require("rxjs/observable/of");
var zip_1 = require("rxjs/observable/zip");
var HierarchicalSearchDeserializationService = /** @class */ (function () {
    function HierarchicalSearchDeserializationService(currentLanguageProvider, languageService) {
        this.currentLanguageProvider = currentLanguageProvider;
        this.languageService = languageService;
    }
    HierarchicalSearchDeserializationService.prototype.deserializeEntities = function (hierarchicalEntitiesData$, categoryFieldsMapping) {
        var _this = this;
        var serviceResponse = new idm_de_service_client_js_1.ServiceResponseDefault();
        var language$ = this.currentLanguageProvider.getCurrentLanguage();
        return zip_1.zip(hierarchicalEntitiesData$, language$).pipe(operators_1.mergeMap(function (data) {
            var entitiesData = data[0];
            var currentLanguageId = data[1].getId();
            var entityItems = entitiesData.data;
            var searchItems = [];
            if (entityItems.length > 0) {
                searchItems = entityItems.map(function (entityItem) {
                    return _this.createHierarchicalSearchItem(entityItem, categoryFieldsMapping, currentLanguageId);
                });
            }
            // init service response
            var meta = new idm_de_service_client_js_1.Meta();
            meta.setTotalRowCount(entitiesData.meta.totalRowCount);
            serviceResponse.setMeta(meta);
            serviceResponse.setData(searchItems);
            return of_1.of(serviceResponse);
        }));
    };
    HierarchicalSearchDeserializationService.prototype.createHierarchicalSearchItem = function (entityItem, categoryFieldsMapping, currentLanguageId) {
        var fieldValueMapping = this.constructFieldValueMapping(entityItem, categoryFieldsMapping);
        var displayName = this.constructDisplayName(entityItem, currentLanguageId);
        return new model_1.HierarchicalSearchItem(displayName, fieldValueMapping, entityItem);
    };
    HierarchicalSearchDeserializationService.prototype.constructFieldValueMapping = function (entityItem, categoryFieldsMapping) {
        var fieldValueMapping = immutable_1.Map();
        if (entityItem.path.length > 0) {
            fieldValueMapping = fieldValueMapping.withMutations(function (mutable) {
                entityItem.path.forEach(function (pathItem) {
                    var constructField = categoryFieldsMapping.get(pathItem.category);
                    mutable.set(constructField, pathItem.id);
                });
            });
        }
        var metaFieldName = categoryFieldsMapping.get(entityItem.category);
        return fieldValueMapping.set(metaFieldName, entityItem.id);
    };
    HierarchicalSearchDeserializationService.prototype.constructDisplayName = function (entityItem, currentLanguageId) {
        var displayNames = [];
        if (entityItem.path.length > 0) {
            displayNames = entityItem.path.map(function (pathItem) {
                return pathItem.name[currentLanguageId];
            });
        }
        displayNames.push(entityItem.name[currentLanguageId]);
        displayNames.reverse();
        return displayNames.join(', ');
    };
    HierarchicalSearchDeserializationService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_message_language_service_client_js_1.LanguageService])
    ], HierarchicalSearchDeserializationService);
    return HierarchicalSearchDeserializationService;
}());
exports.HierarchicalSearchDeserializationService = HierarchicalSearchDeserializationService;
//# sourceMappingURL=hierarchical-search-deserialization.service.js.map